import { render, staticRenderFns } from "./consolidateConsum.vue?vue&type=template&id=215e0716"
import script from "./consolidateConsum.vue?vue&type=script&lang=js"
export * from "./consolidateConsum.vue?vue&type=script&lang=js"
import style0 from "./consolidateConsum.vue?vue&type=style&index=0&id=215e0716&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports